<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-2" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="8" xl="8" cols="12">
          <div class="title_page ma-3 mb-0">
            <h4 class="breadcrumb_title_page">แก้ไขสมัครสมาชิก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="4" xl="4" cols="12">
          <div class="text-center ma-3 ">
            <v-btn elevation="3" color="#D6BFAF"
              style="border-radius: 10px;background-color: #FFFFFF;cursor:unset;height: 50px;" title="แก้ไขรายละเอียด"
              outlined>
              <div class="logo_timeline mx-auto my-auto">
                <img src="@/assets/arin_assets/crown.png">
              </div>
              <div class="ml-2" style="color: #D6BFAF">หมายเลขสมาชิก {{customer_set.member_code}}</div>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <div class="mt-2">
        <v-card elevation="3" class="pa-7" style="border-radius: 15px;">
          <v-form ref="form" @submit.prevent="customer_save">
            <template>
              <v-row>
                <v-col cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/avatar_white.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">ข้อมูลทั่วไป</div>
                    </div>
                  </div>
                </v-col>

                <v-col md="7" lg="7" cols="12">
                  <div class="text_title mt-2">ชื่อ - สกุล <span class="red--text">*</span></div>
                  <div class="mt-2">
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                      :rules="[v => !!v || 'กรุณากรอกข้อมูล']" hide-details="auto" v-model="customer_set.member_name"
                      placeholder="กรุณากรอกชื่อ - สกุล" outlined dense required></v-text-field>
                  </div>
                </v-col>

                <v-spacer></v-spacer>


                <v-col sm="12" md="5" lg="5" cols="12">
                  <v-form-group>
                    <label class="label_form_text">เบอร์โทร </label>
                    <v-otp-input class="mt-2" type="number" hide-details="auto" color="#D6BFAF" v-model="customer_set.tel_number"
                      length="10" @keypress="isNumber($event, customer_set.tel_number)" @paste="isPaste($event)"
                      placeholder="x"  single-line outlined dense
                      ></v-otp-input>
                  </v-form-group>
                </v-col>
              

                <v-spacer></v-spacer>

                <v-col sm="12" md="7" lg="7" cols="12">
                  <v-form-group>
                    <label class="label_form_text">เลขที่เสียภาษี</label>
                    <v-otp-input class="mt-2" type="number" hide-details="auto" color="#D6BFAF" v-model="customer_set.tax_number"
                      length="13" @keypress="isNumber($event, customer_set.tax_number)" @paste="isPaste($event)"
                      placeholder="x" single-line outlined dense></v-otp-input>
                  </v-form-group>
                </v-col>

                <v-spacer></v-spacer>

                  <v-col md="5" lg="5" cols="12">
                    <div class="text_title mt-2">เลขที่สาขา </div>
                    <div class="mt-2">
                      <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                         hide-details="auto" v-model="customer_set.branch_number"
                        placeholder="กรุณากรอกเลขที่สาขา" outlined dense required></v-text-field>
                    </div>
                  </v-col>




                <v-spacer></v-spacer>


                <v-col cols="12">
                  <div class="text_title mt-2">ที่อยู่</div>
                  <div class="mt-2">
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-home" hide-details="auto"
                      v-model="customer_set.address" placeholder="กรุณากรอกที่อยู่" single-line outlined
                      dense></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12 pt-0">
                  <div class="">
                    <v-autocomplete color="#D6BFAF" class="input-radius" hide-details="auto" :items="addressList"
                      item-text="name" item-value="name" v-model="customer_set.sub_district"
                      placeholder="ตำบล /อำเภอ /จังหวัด /รหัสไปรษณีย์ " single-line outlined dense>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="d-flex">
                    <div class="title_form_main">
                      <div class="logo_timeline">
                        <img src="@/assets/arin_assets/notearin.png">
                      </div>
                    </div>
                    <div class="header-content py-1 pl-5 pr-5 text-center">
                      <div class="content-font">โน๊ต</div>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12">
                  <div class="text_title mt-2">โน๊ต</div>
                  <v-textarea color="#D6BFAF" class="input-radius" hide-details="auto" v-model="customer_set.note"
                    required placeholder="กรุณากรอกโน๊ต" outlined></v-textarea>
                </v-col>
                <!-- 
                  <div class="text-center mt-6 mb-3">
                    <v-btn type="submit" class="white--text grad-success-arin-bg mobile_btn" style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
                  </div> -->
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="title_page ma-3" style="justify-content:center;">
                    <v-btn type="submit" class="btn_add_data" elevation="4" large>บันทึก</v-btn>
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import img_holder_document from "@/assets/arin_assets/image_document.png";
import img_holder_cert from "@/assets/arin_assets/image_certification.png";
import Swal from "sweetalert2";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Edit_customer_point",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      img_holder_document: img_holder_document,
      img_holder_cert: img_holder_cert,
      imagePreviewURL: null,
      customer_set: [],
      addressList: [],
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'การสะสมแต้มลูกค้า',
          disabled: false,
        },
        {
          text: 'รายการสมาชิก',
          disabled: false,
        },
        {
          text: 'แก้ไขสมัครสมาชิก',
          disabled: false,
          href: '#',
        },
      ],
    }
  },
  methods: {
    getAddress_api() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/stores/addresslist', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.addressList = res.data.addressList;
        }
      })
    },
    getMember() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/member/get/byid/' + this.$route.params.id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.customer_set = res.data.memberData;
        }
      })
    },
    customer_save() {
      if (this.$refs.form.validate()) {
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.post('/member/edit/' + this.$route.params.id, this.customer_set, config)
          .then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'แก้ไขข้อมูลข้อมูลสมาชิกเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { }, 100)
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.href = '/arin/pos/customerpointlist';
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: res.data.message,
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
      }
    }
  },
  mounted() {
    this.getMember()
    this.getAddress_api()
  }
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */
.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  /* width: 25px;
  height: 25px; */
}

.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 25%;
}

.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}


.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 15%;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }
}
</style>
